{
  "chapel": {
    "u": 7.0,
    "v": 0.0,
    "angleDeg": -90,
    "u0": -16.0,
    "chordU": 15.0,
    "vc": 0,
    "half": 4.2,
    "eaveY": 12.0,
    "ridgeY": 20.8
  },
  "belfry": {
    "u": -4.8,
    "v": 0,
    "radius": 0.43,
    "foot": 19.8,
    "eaves": 22.1,
    "tip": 27.0
  },
  "ranges": [
    {
      "id": "chapel-side-hall",
      "u": -0.6,
      "v": -5.5,
      "angleDeg": -90,
      "length": 17,
      "width": 6.8,
      "eaves": 8.9,
      "ridge": 13.1,
      "floors": 2,
      "bays": 5,
      "roof": "slate",
      "passage": 0,
      "blindSides": [2],
      "windowRows": [
        {
          "sill": 1.2,
          "top": 3.3,
          "round": true,
          "width": 1.0
        },
        {
          "sill": 5.2,
          "top": 6.8,
          "width": 0.75
        }
      ]
    },
    {
      "id": "shorter-rear-body",
      "u": -6.8,
      "v": -7,
      "angleDeg": -90,
      "length": 18,
      "width": 5.6,
      "eaves": 7.5,
      "ridge": 11.6,
      "floors": 2,
      "bays": 4,
      "roof": "slate",
      "passage": 0,
      "blindSides": [2]
    },
    {
      "id": "heiligeweg-gate-range",
      "u": -7,
      "v": 5.9,
      "angleDeg": 0,
      "length": 14,
      "width": 5.8,
      "eaves": 8.6,
      "ridge": 12.5,
      "floors": 2,
      "bays": 5,
      "roof": "slate",
      "passage": 2.8,
      "passageU": -4,
      "roofGables": {
        "centres": [-4.8, 0, 4.8],
        "halfWidth": 0.62,
        "v0": 0.8,
        "v1": 2.9,
        "eaves": 11.7,
        "ridge": 13.0,
        "sill": 9.7,
        "top": 10.6
      }
    },
    {
      "id": "lower-court-return",
      "u": -13.9,
      "v": -15,
      "angleDeg": 0,
      "length": 7.4,
      "width": 5,
      "eaves": 4.2,
      "ridge": 7.3,
      "floors": 1,
      "bays": 2,
      "roof": "tile",
      "passage": 0,
      "doorSide": 2
    }
  ],
  "floors": [
    {
      "ring": [
        [-17.7, -12.4],
        [-9.8, -12.4],
        [-9.8, 2.85],
        [-17.7, 2.85]
      ],
      "height": 0.025,
      "garden": false
    },
    {
      "ring": [
        [-17.7, 2.9],
        [-14.1, 2.9],
        [-14.1, 7.7],
        [-17.7, 4.5]
      ],
      "height": 0.025,
      "garden": false
    },
    {
      "ring": [
        [-12.4, 8.95],
        [-4.1, 8.95],
        [-4.1, 11.7],
        [-9.8, 11.7]
      ],
      "height": 0.025,
      "garden": false
    },
    {
      "ring": [
        [-16.6, -10.8],
        [-11, -10.8],
        [-11, 1.7],
        [-16.6, 1.7]
      ],
      "height": 0.04,
      "garden": true
    }
  ],
  "walls": [
    {
      "from": [-18.0, -17.8],
      "to": [-18.0, 4.5],
      "width": 0.35,
      "height": 1.8
    },
    {
      "from": [-18.0, -17.8],
      "to": [2.6, -17.8],
      "width": 0.35,
      "height": 1.8
    },
    {
      "from": [0, 8.8],
      "to": [2.7, 8.8],
      "width": 0.35,
      "height": 1.8
    }
  ],
  "note": "The Heiligeweg Clarissen is identified by its label in the 1544 woodcut, distinct from Sint Clara at the Nes. The 1538 painting and woodcut show a high gabled chapel, adjoining shorter parallel bodies, a lower cross range and open ground, rather than a small chapel behind four equal garth ranges. Its chapel and adjoining roofs now recede perpendicular to the old generic chapel axis. This bounded reconstruction retains the existing estimated dry precinct; it does not claim to recover the entire painted garden or all annexes. All component dimensions, heights, roof gables, coverings, windows, belfry, private gate, soil edges, hidden connections and precise property boundaries are fitted estimates. The later Rasphuis court and 1603 portal are not backdated. The reported 1513 maximum of 60 square roeden is a legal-use condition, not a dimensioned survey of every visible building and garden."
}
